import React from 'react'
import FocusedHeader from './FocusedHeader'

export default function RetryError({ send }) {
  return (
    <div className="spacing">
      <FocusedHeader>Something went wrong</FocusedHeader>
      <p>
        Oops, we encountered an unexpected error. If this continues to happen, please contact us at
        hello@reacttraining.com
      </p>
      <div>
        <button onClick={() => send('TRY_AGAIN')} className="button">
          Retry
        </button>
      </div>
    </div>
  )
}
